import { Typography } from 'antd'
import VSpace from '../common/VSpace'
import RichTextEditor from '../RichTextEditor/RichTextEditor'
import { getDownPaymentInvoiceLineItems, LineItem, setDownPaymentInvoiceDescription } from './lineItemsModel'
import { Action, setLineItem } from './proposalsModel'

const { Text } = Typography

type Props = {
  lineItems: LineItem[]
  dispatch: (action: Action) => void
}

const DownPaymentInvoiceDescriptions = ({ lineItems, dispatch }: Props) => {
  const downPaymentLineItems = getDownPaymentInvoiceLineItems(lineItems)
  if (downPaymentLineItems.length === 0) {
    return null
  }

  return <VSpace>
    <strong>Down Payment Invoice Descriptions</strong>
    <Text type="secondary">
      The description each down payment invoice will use. Changes here apply only to the down payment invoice, not to the proposal or the plan.
    </Text>
    {downPaymentLineItems.map(lineItem => <VSpace key={lineItem.id} size="small">
      <span>{lineItem.title}</span>
      <RichTextEditor
        value={lineItem.downPaymentInvoiceDescription ?? ''}
        onChange={value => dispatch(setLineItem(lineItem.id, setDownPaymentInvoiceDescription(value)))}
      />
    </VSpace>)}
  </VSpace>
}

export default DownPaymentInvoiceDescriptions
